/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssignmentRule } from './AssignmentRule';
import {
    AssignmentRuleFromJSON,
    AssignmentRuleFromJSONTyped,
    AssignmentRuleToJSON,
} from './AssignmentRule';

/**
 * 
 * @export
 * @interface CreateAssignmentRule201Response
 */
export interface CreateAssignmentRule201Response {
    /**
     * 
     * @type {AssignmentRule}
     * @memberof CreateAssignmentRule201Response
     */
    data: AssignmentRule;
}

/**
 * Check if a given object implements the CreateAssignmentRule201Response interface.
 */
export function instanceOfCreateAssignmentRule201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateAssignmentRule201ResponseFromJSON(json: any): CreateAssignmentRule201Response {
    return CreateAssignmentRule201ResponseFromJSONTyped(json, false);
}

export function CreateAssignmentRule201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssignmentRule201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': AssignmentRuleFromJSON(json['data']),
    };
}

export function CreateAssignmentRule201ResponseToJSON(value?: CreateAssignmentRule201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AssignmentRuleToJSON(value.data),
    };
}

